import { useAppDispatch } from "Components/Hooks/hooks";
import { updateQuoteStatus } from "slices/thunks";
import { QuoteDetailsPayload } from "types/quote.api";
import { getStatusBadge } from "utils/getStatusBatch";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import React, { useState } from "react";

interface QuoteBasicInfoProps {
  quote: QuoteDetailsPayload;
}

const QuoteBasicInfo: React.FC<QuoteBasicInfoProps> = ({ quote }) => {
  const disPatch = useAppDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const STATUS_GROUPS = [
    ["draft", "completed"],
    ["sent", "approved"],
    ["rejected", "cancelled"],
  ];
  const changeStatus = (status: string) => {
    disPatch(updateQuoteStatus({ status: status, quote_id: quote.id }));
  };

  return (
    <div className="d-flex flex-column p-3 bg-white br-10">
      {/* Title */}
      <div className="fw-medium fs-16 text-black2D">Basic Information</div>

      {/* Border */}
      <div className="border-bottom my-3 mx-n4"></div>

      {/* Table-like layout */}
      <div className="d-flex flex-column gap-3">
        {/* Row: Quote Ref */}
        <div className="d-flex align-items-center">
          <div
            className="text-grey2D fw-normal fs-14 font-primary"
            style={{ width: "120px" }}
          >
            Quote Ref.
          </div>
          <div className="text-grey89 fw-normal fs-14 font-primary">
            {quote.reference_number}
          </div>
        </div>

        {/* Row: Created On */}
        <div className="d-flex align-items-center">
          <div
            className="text-black2D fw-normal fs-14 font-primary"
            style={{ width: "120px" }}
          >
            Created On
          </div>
          <div className="text-grey89 fw-normal fs-14 font-primary">
            {quote.quote_date}
          </div>
        </div>

        {/* Row: Due Date */}
        <div className="d-flex align-items-center">
          <div
            className="text-black2D fw-normal fs-14 font-primary"
            style={{ width: "120px" }}
          >
            Expiry Date
          </div>
          <div className="text-grey89 fw-normal fs-14 font-primary">
            {quote.expiry_date}
          </div>
        </div>

        {/* Row: Status */}
        <div className="d-flex align-items-center">
          <div
            className="text-black2D fw-normal fs-14 font-primary"
            style={{ width: "120px" }}
          >
            Status
          </div>
          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle tag="div" className="cursor-pointer">
              {getStatusBadge(quote.status, true)}
            </DropdownToggle>
            <DropdownMenu>
              {STATUS_GROUPS.flat().map((status) => (
                <DropdownItem
                  key={status}
                  onClick={() => changeStatus(status)}
                  active={quote.status === status}
                  className="text-capitalize"
                >
                  {status}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default QuoteBasicInfo;
